<template>
  <div class="h-screen flex w-full bg-img" :style="`background-image: url('/assets/images/pages/login-bg_${appFilename}.jpg')`">
    <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/pages/forgot-password.png" alt="login" class="mx-auto" />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">Recuperar sua senha</h4>
                  <p>Digite seu e-mail abaixo e enviaremos as instruções para seu e-mail.</p>
                </div>

                <vs-input type="email" label-placeholder="E-mail" v-model="email" class="w-full mb-8" />
                <vs-button type="border" :to="returnTo" class="px-4 w-full md:w-auto">Voltar</vs-button>
                <vs-button
                  class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0"
                  @click="resetPassword"
                >Enviar</vs-button>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      returnTo: '/pages/login',
      appFilename: process.env.VUE_APP_FILENAME,
    };
  },
  mounted() {
    if (this.$route.query.returnTo) {
      this.returnTo = this.$route.query.returnTo
    }
  },
  methods: {
    resetPassword() {
      this.$api
        .post("/api/v1/auth/forgotPassword", {
          email: this.email
        })
        .then(() => {
          this.$vs.notify({
            time: 6000,
            title: "Aviso",
            text: "Você receberá um e-mail em alguns minutos.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });

          this.$router.push(this.returnTo);
        })
        .catch(error => {
          this.$vs.notify({
            time: 6000,
            title: "Aviso",
            text: error.response.data.error || error.response.data.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        });
    }
  }
};
</script>
